import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Login.css';
import Logo from './Logo';
import { saveAuthSession } from '../utils/authStorage';

function Login() {
  const [cnpj, setCnpj]       = useState('');
  const [senha, setSenha]     = useState('');
  const [erro, setErro]       = useState('');
  const [loading, setLoading] = useState(false);
  const [mostrarPrimeiroAcesso, setMostrarPrimeiroAcesso] = useState(false);
  const [mostrarAvisoEsqueciSenha, setMostrarAvisoEsqueciSenha] = useState(false);
  const navigate = useNavigate();

  const formatarDocumento = (valor) => {
    const n = valor.replace(/\D/g, '');
    if (n.length <= 11) {
      return n
        .replace(/^(\d{3})(\d)/, '$1.$2')
        .replace(/^(\d{3})\.(\d{3})(\d)/, '$1.$2.$3')
        .replace(/\.(\d{3})(\d)/, '$1-$2')
        .slice(0, 14);
    }
    return n
      .replace(/^(\d{2})(\d)/, '$1.$2')
      .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
      .replace(/\.(\d{3})(\d)/, '.$1/$2')
      .replace(/(\d{4})(\d)/, '$1-$2')
      .slice(0, 18);
  };

  const handleDocumentoChange = (e) => setCnpj(formatarDocumento(e.target.value));
  const handleSenhaChange = (e) => setSenha(e.target.value);
  const handleLogoClick = () => window.location.reload();
  const irParaPrimeiroAcesso = () => navigate('/primeiro-acesso');
  const irParaEsqueciSenha = () => {
    setMostrarAvisoEsqueciSenha(true);
    setTimeout(() => {
      setMostrarAvisoEsqueciSenha(false);
    }, 5000); // Oculta após 5 segundos
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');
    const documentoLimpo = cnpj.replace(/\D/g, '');
    if (!documentoLimpo) { setErro('CNPJ/CPF é obrigatório'); return; }
    if (documentoLimpo.length !== 11 && documentoLimpo.length !== 14) {
      setErro('Digite um CPF válido (11 dígitos) ou CNPJ válido (14 dígitos)');
      return;
    }
    if (!senha) { setErro('Senha é obrigatória'); return; }
    setLoading(true);
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ documento: documentoLimpo, senha: senha }),
      });
      const data = await response.json();
      if (data.ok && data.token) {
        saveAuthSession({
          token: data.token,
          customerId: data.customerId,
          customerName: data.customerName,
          customerCnpj: data.documento,
        });
        navigate('/dashboard');
      } else {
        setErro(data.erro || 'Erro na autenticação. Verifique seu CNPJ/CPF.');
      }
    } catch {
      setErro('Erro ao conectar com o servidor. Tente novamente.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-logo-area">
          <Logo size="large" onClick={handleLogoClick} />
          <p className="login-subtitle">Bem-vindo ao Portal do Cliente</p>
        </div>
        <div className="login-form-area">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="cnpj">CNPJ/CPF</label>
              <input
                type="text"
                id="cnpj"
                value={cnpj}
                onChange={handleDocumentoChange}
                placeholder="00.000.000/0000-00"
                disabled={loading}
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="senha">Senha</label>
              <input
                type="password"
                id="senha"
                value={senha}
                onChange={handleSenhaChange}
                placeholder="Digite sua senha"
                disabled={loading}
                required
              />
            </div>
            {erro && <div className="erro-mensagem">{erro}</div>}
            <button type="submit" className="btn-login" disabled={loading}>
              {loading ? 'Verificando...' : 'Acessar Portal'}
            </button>
            
            <div className="login-links">
              <button 
                type="button" 
                className="link-btn" 
                onClick={irParaPrimeiroAcesso}
                disabled={loading}
              >
                Primeiro Acesso
              </button>
              <span className="link-separator">|</span>
              <button 
                type="button" 
                className="link-btn" 
                onClick={irParaEsqueciSenha}
                disabled={loading}
              >
                Esqueci a Senha
              </button>
              {mostrarAvisoEsqueciSenha && (
                <div className="aviso-desenvolvimento">
                  <span className="icone-aviso">!</span>
                  <span className="texto-aviso">Funcionalidade em desenvolvimento</span>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Login;
